import { imgProps } from "../../lib/api";
import { useLang } from "../../i18n";
import { Reveal } from "../Reveal";

export default function ProjectGallery({ project, title }) {
  const { t } = useLang();
  return (
    <>
        {project.gallery?.length > 1 && (
          <Reveal className="mt-20">
            <p className="text-xs uppercase tracking-[0.25em] font-mono text-[#C8A86B]">{t.gallery_title}</p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
              {project.gallery.map((g, i) => (
                <div key={g} className={`overflow-hidden border border-[#262420] ${i === 0 ? "sm:col-span-2" : ""}`}>
                  <img {...imgProps(g, i === 0 ? "100vw" : "(max-width: 640px) 100vw, 50vw")} alt={`${title} — ${i + 1}`} loading="lazy" className="w-full object-cover transition-transform duration-700 hover:scale-105" />
                </div>
              ))}
            </div>
          </Reveal>
        )}

    </>
  );
}
